<template>
  <div>
    <span v-if="taxData === null"
      class="desc-text">{{ $t('api.noData') }}</span>
    <el-card v-if="taxData"
      class="box-card">
      <div slot="header" class="clearfix">
        {{ $t('api.orders.tax') }}
      </div>
      <div>
        <text-field
          v-model="taxData.tax_id"
          :base="base"
          name="tax_id"
          :disabled="true"
          :hasDesc="true"
          >
        </text-field>
        <text-field
          v-model="taxData.company_name"
          :base="base"
          name="tax_company_name"
          :disabled="true"
          :hasDesc="true"
          >
        </text-field>
        <text-field
          v-model="taxData.receipt_company"
          :base="base"
          name="tax_receipt_company"
          :disabled="true"
          :hasDesc="true"
          >
        </text-field>
        <text-field
          v-model="taxData.email"
          :base="base"
          name="tax_email"
          :disabled="true"
          >
        </text-field>
      </div>
    </el-card>
  </div>
</template>

<script>

import { getTransText } from '@/utils/i18n'

export default {
  name: 'orders-invoice',
  props: {
    base: {
      type: String,
      default: ''
    },
    tax: null
  },
  data () {
    return {
      taxData: this.tax
    }
  },
  methods: {
    getTransText
  },
  mounted () {
  },
  watch: {
    tax (newValue) {
      this.taxData = newValue
    }
  }
}
</script>
